export default {
	state: {
		contratacaoEmp: {}
	},
	getters: {
		"contratacaoEmp": state => state.contratacaoEmp
	},
	mutations: {
		setContratacaoEmp(state, payload) {
			state.contratacaoEmp = payload
		}
	},
	actions: {
		atualizarEstadoContratacaoEmp({ commit }, payload) {
			commit('setContratacaoEmp', payload)
		}
	}
};